import React from 'react'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import LandingRouter from './LandingRouter'
import HomeRouter from './HomeRouter'
import ErrorBoundary from '@components/suspense/ErrorBoundary'
import GlobalErrorFallBack from '@components/suspense/GlobalErrorFallBack'
import QueryBoundary from '@components/suspense/QueryBoundary'
import AdminRouter from './AdminRouter'

const Router = () => {
  return (
    <>
      <Suspense fallback={<></>}>
        <ErrorBoundary fallback={<GlobalErrorFallBack />}>
          <QueryBoundary modalMode>
            <Routes>
              <Route path="/*" element={<LandingRouter />} />
              <Route path="/home/*" element={<HomeRouter />} />
              <Route path="/admin/*" element={<AdminRouter />} />
            </Routes>
          </QueryBoundary>
        </ErrorBoundary>
      </Suspense>
    </>
  )
}

export default Router
